// extracted by mini-css-extract-plugin
module.exports = {"toggle":"switch_toggle__lmuQi","slider":"switch_slider__m3aEf","input":"switch_input__ydFSU"};